import React, { useEffect, useState } from "react";
import axios from "axios";

function RegistrationHelpDetails({ isDesktop }) {
  const [helpDetails, setHelpDetails] = useState("");
  const language = localStorage.getItem("language");
  let selectedPage = window?.location?.href
    ?.split("/")
    ?.pop()
    ?.split("=")
    ?.pop();
  let decodedModuleName = decodeURIComponent(selectedPage);

  const getSelectedPageDetails = async () => {
    await axios.get(`/api/content?type=help`).then((res) => {
      let allResults = res?.data?.data?.results;
      let selectedPageDetails = allResults?.filter((item) => item?._id === selectedPage || item?.helpContent?.pageName === decodedModuleName)[0];
      setHelpDetails({
        ...selectedPageDetails,
        englishContent: (language === "english" && selectedPageDetails?.englishContent) || "",
        arabicContent: (language === "arabic" && selectedPageDetails?.arabicContent) || "",
      });
    });
  };

  useEffect(() => {
    getSelectedPageDetails();
    //eslint-disable-next-line
  }, []);

  const getContent = () => {
    if (!helpDetails) return "";
    return (language === "arabic" ? helpDetails.arabicContent : helpDetails.englishContent) === (undefined || "undefined")
      ? ""
      : language === "arabic"
      ? helpDetails?.arabicContent
      : helpDetails?.englishContent;
  };

  const selectedLanguage = localStorage.getItem("language");
  return (
    <div style={{ paddingTop: "0rem", paddingBottom: "2rem", minHeight: "60vh" }} className={`${selectedLanguage === "arabic" ? "rtl" : "ltr"}`}>
      <div style={{ paddingTop: "0rem" }} className="terms-content" dangerouslySetInnerHTML={{ __html: getContent() }} />
    </div>
  );
}

export default RegistrationHelpDetails;
